/* eslint-disable camelcase */
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';


export default class GoogleCCaaSService_Ext {
    static getGoogleCCaaSAccessToken(data,additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('chat'), 'getGoogleCCaaSAccessToken', [data], additionalHeaders);
    }

    static getChatToken(data,additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('chat'), 'getChatToken', [data], additionalHeaders);
    }
}
